export interface IMountingTypeModel {
  name: string;
  code: string;
  mountingTypeId: number;
}

export class MountingTypeModel implements IMountingTypeModel {
  name: string;
  code: string;
  mountingTypeId: number;

  public constructor() {
    this.name = "";
    this.code = "";
    this.mountingTypeId = 0;
  }
}
